"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _propTypes = require("prop-types");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require("styled-components");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _reactGridLayout = require("react-grid-layout");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

require("react-grid-layout/css/styles.css");
require("react-resizable/css/styles.css");

var ResponsiveReactGridLayout = (0, _reactGridLayout.WidthProvider)(_reactGridLayout.Responsive);

var Dashboard = function (_Component) {
    _inherits(Dashboard, _Component);

    function Dashboard() {
        _classCallCheck(this, Dashboard);

        return _possibleConstructorReturn(this, (Dashboard.__proto__ || Object.getPrototypeOf(Dashboard)).apply(this, arguments));
    }

    _createClass(Dashboard, [{
        key: "render",
        value: function render() {
            return _react2.default.createElement(
                ResponsiveReactGridLayout,
                this.props,
                this.props.children
            );
        }
    }]);

    return Dashboard;
}(_react.Component);

Dashboard.displayName = "Dashboard";
Dashboard.propTypes = {
    /** Optional, but if you are managing width yourself you may want to set the breakpoint yourself as well.*/
    breakpoint: _propTypes2.default.string,

    /** {name: pxVal}, e.g. {lg: 1200, md: 996, sm: 768, xs: 480}*/
    breakpoints: _propTypes2.default.object,

    /** # of cols per breakpoint. This is a breakpoint -> cols map*/
    cols: _propTypes2.default.object,

    /** layouts is an object mapping breakpoints to layouts.
     e.g. {lg: Layout, md: Layout, ...}, there's more to it than this, but we'll let the wrapped react-grid-layout handle the extra checks */
    layouts: _propTypes2.default.object,

    /** The width of this component.*/
    width: _propTypes2.default.number,

    /** The height of each of the rows in the dashboard.*/
    rowHeight: _propTypes2.default.number,

    /** Calls back with breakpoint and new number of cols */
    onBreakpointChange: _propTypes2.default.func,

    /** Callback so you can save the layout.
     Calls back with (currentLayout, allLayouts). allLayouts are keyed by breakpoint.*/
    onLayoutChange: _propTypes2.default.func,

    /** Calls back with (containerWidth, margin, cols, containerPadding)*/
    onWidthChange: _propTypes2.default.func,

    /** A css class selector of the class to be used as a drag handle in each panel,
     * if using the DashboardPanel component this should be set to ".dragHandle"
     * NOTE: This is not defaulted as if missing the whole panel is treated as the drag handle */
    draggableHandle: _propTypes2.default.string
};

Dashboard.defaultProps = {
    cols: { lg: 12, md: 12, sm: 6, xs: 4, xxs: 2 },
    width: 1200,
    rowHeight: 30
};

exports.default = Dashboard;


//////////////////
// WEBPACK FOOTER
// ./~/rla-components/dist/components/Dashboard.js
// module id = 985
// module chunks = 95715928098905 168707334958949